import { ButtonSound } from '@jollywise/jollygoodgame';
import { EnemyHealthBar } from '../display/EnemyHealthBar';
import { GameHud } from '../display/GameHud';
import { HudPlayerCoins } from '../display/ui/HudPlayerCoins';
import { ButtonSoundTT } from '../input/ButtonSoundTT';
import { ButtonTT } from '../input/ButtonTT';

export const HudConfig = {
  modal: { imagekey: 'overlay_purple', alpha: 1 },
  defaultButton: ButtonTT,
  howtoplay: [],
  buttons: [
    // =============================================================================================
    // GLOBAL BUTTONS
    // =============================================================================================

    {
      id: 'btn_start_game',
      costume: 'btn_play',
      buttongroup: 'bottomright',
      event: 'START_GAME',
      keymap: 'SPACE',
    },
    {
      id: 'btn_sound',
      costume: 'btn_sound_on',
      buttongroup: 'topright',
      buttonClass: ButtonSoundTT,
      event: 'TOGGLE_SOUND',
    },
    {
      id: 'btn_pause',
      costume: 'btn_pause',
      buttongroup: 'topright',
      event: 'PAUSE_GAME',
    },
    {
      id: 'btn_resume',
      costume: 'btn_play',
      buttongroup: 'bottomright',
      event: 'RESUME_GAME',
    },
    {
      id: 'btn_home',
      costume: 'btn_home',
      buttongroup: 'topleft',
      event: 'RETURN_HOME',
    },
    {
      id: 'btn_changecharacter',
      costume: 'btn_changecharacter',
      buttongroup: 'bottom',
      event: 'CHARACTER_SELECT',
    },
    {
      id: 'btn_replay_stage',
      costume: 'btn_replay',
      buttongroup: 'replaycenter',
      event: 'REPLAY_STAGE',
    },
    {
      id: 'btn_unlocks',
      costume: 'btn_unlocks',
      buttongroup: 'bottomleft',
      event: 'SHOW_UNLOCKS',
    },
    {
      id: 'btn_continue_story',
      costume: 'btn_play',
      buttongroup: 'bottomright',
      event: 'PLAY_STORY_STAGE',
      keymap: 'SPACE',
    },

    // =============================================================================================
    // BASIC BUTTONS
    // =============================================================================================

    {
      id: 'btn_skip',
      costume: 'btn_skip',
      buttongroup: 'bottomright',
      keymap: 'SPACE',
    },
    {
      id: 'btn_back',
      costume: 'btn_back',
      buttongroup: 'topleft',
    },
    {
      id: 'btn_back_overlay',
      costume: 'btn_back',
      buttongroup: 'topleft',
      event: 'CLOSE_OVERLAY',
    },
    {
      id: 'btn_continue',
      costume: 'btn_play',
      buttongroup: 'bottomright',
      keymap: 'SPACE',
    },
    {
      id: 'btn_newgame',
      costume: 'btn_newgame',
      buttongroup: 'bottomright',
    },
    {
      id: 'btn_cancel',
      costume: 'btn_cancel',
      buttongroup: 'confirmcenter',
    },
    {
      id: 'btn_confirm',
      costume: 'btn_confirm',
      buttongroup: 'confirmcenter',
    },
    {
      id: 'btn_confirm_back',
      costume: 'btn_back_wide',
      buttongroup: 'confirmcenter',
    },
    {
      id: 'btn_cycle_prev',
      costume: 'btn_prev',
      buttongroup: 'bottomleft',
    },
    {
      id: 'btn_cycle_next',
      costume: 'btn_next',
      buttongroup: 'bottomright',
    },

    // =============================================================================================
    // TEMP BUTTONS
    // =============================================================================================

    {
      id: 'btn_stage_die',
      costume: 'btn_cancel',
      buttongroup: 'bottomright',
    },
    {
      id: 'btn_stage_complete',
      costume: 'btn_confirm',
      buttongroup: 'bottomright',
    },

    // =============================================================================================
    // COMPONENTS
    // =============================================================================================

    {
      id: 'player_coins',
      classname: HudPlayerCoins,
      buttongroup: 'topright',
      type: 'component',
    },
    {
      id: 'player_coins_game',
      classname: HudPlayerCoins,
      buttongroup: 'top',
      type: 'component',
    },
    {
      id: 'player_coins_pause',
      classname: HudPlayerCoins,
      buttongroup: 'topright',
      type: 'component',
    },
    {
      id: 'game_hud',
      classname: GameHud,
      buttongroup: 'topleft',
      type: 'component',
    },
    {
      id: 'enemy_health',
      classname: EnemyHealthBar,
      buttongroup: 'topright',
      type: 'component',
    },
  ],
  states: {
    EMPTY: {
      buttons: [],
    },
    BASIC: {
      buttons: ['btn_pause'],
    },
    BASIC_HOME: {
      buttons: ['btn_home', 'btn_pause'],
    },
    PAUSE: { buttons: ['btn_home', 'btn_resume', 'player_coins_pause', 'btn_sound'] },
    WELCOME: {
      buttons: ['btn_unlocks', 'btn_start_game', 'btn_sound'],
    },
    CUTSCENE: {
      buttons: ['btn_skip'],
    },
    CHARACTER_SELECT: {
      buttons: ['btn_back', 'player_coins'],
    },
    CHARACTER_SELECT_PROGRESS: {
      buttons: ['btn_back', 'btn_continue', 'player_coins'],
    },
    CHARACTER_SELECT_PROGRESS_PLUS: {
      buttons: ['btn_back', 'btn_newgame', 'btn_continue', 'player_coins'],
    },
    GAMEPLAY: {
      // buttons: ['game_hud', 'enemy_health', 'btn_pause'],
      buttons: ['btn_pause'],
    },
    STAGE_COMPLETE: {
      buttons: ['btn_home', 'btn_unlocks', 'btn_continue'],
    },
    LEVEL_COMPLETE: {
      buttons: ['btn_home', 'btn_unlocks', 'btn_continue_story'],
    },
    GAME_OVER: {
      buttons: ['btn_home', 'btn_changecharacter', 'btn_replay_stage'],
    },
    CONFIRM_HOME: { buttons: ['btn_confirm', 'btn_cancel'] },
    CONFIRM_ACTION: { buttons: ['btn_confirm', 'btn_cancel', 'player_coins'] },
    NO_MONEY: { buttons: ['btn_confirm_back', 'player_coins'] },
    UNLOCKS: {
      buttons: ['btn_back_overlay', 'btn_cycle_prev', 'btn_cycle_next', 'player_coins'],
    },
  },
  buttongroups: {
    top: {
      anchor_group: { x: 0.5, y: 0 },
      anchor_screen: { x: 0.5, y: 0 },
      align_buttons: 'center',
    },
    welcome: {
      anchor_group: { x: 0.5, y: 0.5 },
      anchor_screen: { x: 0.5, y: 0.8 },
      align_buttons: 'center',
    },
    bottomright: {
      anchor_group: { x: 1, y: 1 },
      anchor_screen: { x: 1, y: 1 },
      align_buttons: 'center',
    },
    confirmcenter: {
      anchor_group: { x: 0.5, y: 0.5 },
      anchor_screen: { x: 0.5, y: 0.9 },
      align_buttons: 'center',
      buttonPadding: 40,
    },
    replaycenter: {
      anchor_group: { x: 0.5, y: 0.5 },
      anchor_screen: { x: 0.5, y: 0.6 },
      align_buttons: 'center',
      buttonPadding: 40,
    },
  },
};
